import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { useStyles } from '../SchoolShow_style'
import SVGFactory from 'icons/SVGFactory/SVGFactory'
import Paper from 'components/Paper/Paper'
import SchoolFaqItem from './SchoolFaqItem'

const SchoolFaq = (props) => {
    const { school } = props
    const classes = useStyles()

    return (
        <Paper className={classes.faqPaper}>
            <Box className={classes.faqTitleBox}>
                <Box className={classes.svgCircle}>
                    <SVGFactory
                        name='speak'
                        className={classes.svgIcon}
                    />
                </Box>
                <Typography variant='h1' component='h2' className={classes.faqTitle}>
                    <FormattedMessage id='school_page.faq.title' values={{ school: school.name }}/>
                </Typography>
            </Box>
            <Box className={classes.faqQuestions}>
                {school.faqs.map((faq) => {
                    return <SchoolFaqItem key={`faq-${faq.id}`} faq={faq} />
                })}
            </Box>
        </Paper>
    )
}

export default SchoolFaq
